var _defs, _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivigoLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 124,
    viewBox: "0 0 387 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flagGrad",
    x1: 6,
    y1: 72,
    x2: 110,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98CB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5BC589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "diamondGrad",
    x1: 46,
    y1: 114,
    x2: 86,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1762E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F8DF2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 59 L58 8 Q60.5 6 64 6 L104 6 Q110 6 107 11.5 L41 83 Q37 87.5 32 82.5 L7 60.5 Z",
    fill: "url(#flagGrad)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 74,
    width: 36,
    height: 36,
    rx: 8.5,
    transform: "rotate(45 66 92)",
    fill: "url(#diamondGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(154, 87)",
    fill: "#1E293B"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0.00,0) scale(0.06600,-0.06600)",
    d: "M66 -200V541H174V472Q204 510 250.5 531.5Q297 553 355 553Q432 553 493.5 516.0Q555 479 590.5 415.0Q626 351 626 271Q626 191 590.5 127.0Q555 63 493.5 25.5Q432 -12 355 -12Q301 -12 255.0 7.5Q209 27 179 63V-200ZM344 93Q391 93 428.5 116.0Q466 139 487.5 179.0Q509 219 509 271Q509 322 487.5 362.0Q466 402 428.5 425.0Q391 448 344 448Q296 448 259.0 425.0Q222 402 200.5 362.0Q179 322 179 271Q179 219 200.5 179.0Q222 139 259.0 116.0Q296 93 344 93Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(44.22,0) scale(0.06600,-0.06600)",
    d: "M66 0V541H174V471Q194 512 231.0 530.0Q268 548 318 548H351V445H304Q248 445 213.5 410.0Q179 375 179 312V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(68.11,0) scale(0.06600,-0.06600)",
    d: "M66 615V745H179V615ZM66 0V541H179V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(84.28,0) scale(0.06600,-0.06600)",
    d: "M223 0 11 541H134L274 160L415 541H539L326 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(120.58,0) scale(0.06600,-0.06600)",
    d: "M66 615V745H179V615ZM66 0V541H179V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(136.75,0) scale(0.06600,-0.06600)",
    d: "M327 -220Q238 -220 171.0 -178.5Q104 -137 78 -70L182 -27Q196 -65 233.5 -90.0Q271 -115 326 -115Q390 -115 433.5 -78.5Q477 -42 477 25V92Q447 56 403.5 37.0Q360 18 308 18Q232 18 172.5 53.0Q113 88 78.5 149.0Q44 210 44 286Q44 362 78.0 422.5Q112 483 171.5 518.0Q231 553 307 553Q361 553 405.5 532.0Q450 511 482 472V541H589V25Q589 -46 555.5 -101.5Q522 -157 462.5 -188.5Q403 -220 327 -220ZM321 123Q365 123 400.5 144.5Q436 166 456.5 202.5Q477 239 477 285Q477 331 456.0 368.0Q435 405 400.0 426.5Q365 448 321 448Q275 448 239.0 426.5Q203 405 182.5 368.0Q162 331 162 285Q162 239 182.5 202.5Q203 166 239.0 144.5Q275 123 321 123Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(179.98,0) scale(0.06600,-0.06600)",
    d: "M327 -12Q249 -12 184.5 24.5Q120 61 82.0 125.0Q44 189 44 271Q44 352 81.5 416.0Q119 480 183.5 516.5Q248 553 327 553Q406 553 470.0 516.5Q534 480 571.5 416.5Q609 353 609 271Q609 189 571.0 125.0Q533 61 469.0 24.5Q405 -12 327 -12ZM327 93Q374 93 411.0 116.0Q448 139 470.0 179.5Q492 220 492 271Q492 322 470.0 362.0Q448 402 411.0 425.0Q374 448 327 448Q280 448 242.5 425.0Q205 402 183.5 362.0Q162 322 162 271Q162 220 183.5 179.5Q205 139 242.5 116.0Q280 93 327 93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivigoLogoDark);
export default __webpack_public_path__ + "static/media/privigo-logo-dark.73157ae4a753cc09cb330c2688aac5b0.svg";
export { ForwardRef as ReactComponent };